import React from "react";
import { Form, Row, Col, Accordion } from "react-bootstrap";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";
import FileUploadField from "../../../Common/FileUploadField";

export default function EducationSection({
  employeeData,
  handleInputChange,
  errors,
  deleteFile,
  photoLoad,
  isDisabled,
}) {
  const preventLeadingSpace = (e) => {
    if (e.key === " " && e.currentTarget.value.length === 0) {
      e.preventDefault();
    }
  };

  return (
    <div
      className="bg-white p-4 shadow pb-5 rounded-3"
      style={{
        marginLeft: "0.8rem",
        marginRight: "0.8rem",
        marginBottom: "4rem",
      }}
    >
      {/* Section Heading */}
      <div className="d-flex justify-content-between border-bottom pb-3">
        <h4
          className="text-capitalize icueTextPrimary"
          style={{ color: "#2f4766" }}
        >
          Educational Information
        </h4>
      </div>

      <Accordion defaultActiveKey="0" className="mt-4">
        {/* Class 10th & 12th Details Accordion Item */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>10th & 12th Details</Accordion.Header>
          <Accordion.Body>
            <Row className="mt-3">
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Board of Education (10th)
                  </Form.Label>
                  <Form.Select
                    name="board_of_education"
                    className="  text-muted"
                    value={employeeData.board_of_education}
                    onChange={(e) => handleInputChange(e, "employee")}
                    isInvalid={!!errors.board_of_education}
                    disabled={isDisabled}
                  >
                    <option value="">Select Board</option>
                    <option value="HBSE">HBSE</option>
                    <option value="CBSE">CBSE</option>
                    <option value="ICSE">ICSE</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.board_of_education}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Class 10 Percentage %
                  </Form.Label>
                  <Form.Control
                    className="  text-muted"
                    type="number"
                    name="calss_10_percentage"
                    value={employeeData.calss_10_percentage}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.calss_10_percentage}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.calss_10_percentage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Class 12 Percentage %
                  </Form.Label>
                  <Form.Control
                    className="  text-muted"
                    type="number"
                    name="class_12_percentage"
                    value={employeeData.class_12_percentage}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.class_12_percentage}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.class_12_percentage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Class 12 Stream
                  </Form.Label>
                  <Form.Select
                    name="class_12_stream"
                    className="  text-muted"
                    value={employeeData.class_12_stream}
                    onChange={(e) => handleInputChange(e, "employee")}
                    isInvalid={!!errors.class_12_stream}
                    disabled={isDisabled}
                  >
                    <option value="">Select Stream</option>
                    <option value="Commerce">Commerce</option>
                    <option value="Science">Science</option>
                    <option value="Arts">Arts</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.class_12_stream}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Upload Class 10 Marksheet
                  </Form.Label>
                  <FileUploadField
                    name="class_10_marksheet"
                    value={employeeData.class_10_marksheet}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() => deleteFile("class_10_marksheet")}
                    error={errors.class_10_marksheet}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Upload Class 12 Marksheet
                  </Form.Label>
                  <FileUploadField
                    name="class_12_marksheet"
                    value={employeeData.class_12_marksheet}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() => deleteFile("class_12_marksheet")}
                    error={errors.class_12_marksheet}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* Highest Qualification & Additional Courses */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            Highest Qualification & Certifications
          </Accordion.Header>
          <Accordion.Body>
            <Row className="mt-3">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Highest Qualification
                  </Form.Label>
                  <Form.Select
                    name="highest_qualification"
                    className="  text-muted"
                    value={employeeData.highest_qualification}
                    onChange={(e) => handleInputChange(e, "employee")}
                    isInvalid={!!errors.highest_qualification}
                    disabled={isDisabled}
                  >
                    <option value="">Select Qualification</option>
                    <option value="HighSchool">High School</option>
                    <option value="Bachelors">Bachelors</option>
                    <option value="Masters">Masters</option>
                    <option value="PhD">PhD</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.highest_qualification}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>Degree</Form.Label>
                  <Form.Control
                    type="text"
                    name="dgree"
                    className="  text-muted"
                    value={employeeData.dgree}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.dgree}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.dgree}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Institution/University Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="  text-muted"
                    name="institute_university_name"
                    value={employeeData.institute_university_name}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.institute_university_name}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.institute_university_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Year of Graduation
                  </Form.Label>
                  <Form.Control
                    className="  text-muted"
                    type="number"
                    name="year_of_graduation"
                    value={employeeData.year_of_graduation}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.year_of_graduation}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.year_of_graduation}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Upload Highest Qualification Marksheet
                  </Form.Label>
                  <FileUploadField
                    name="highest_qualification_marksheet"
                    value={employeeData.highest_qualification_marksheet}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() =>
                      deleteFile("highest_qualification_marksheet")
                    }
                    error={errors.highest_qualification_marksheet}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Upload Degree
                  </Form.Label>
                  <FileUploadField
                    name="degree_upload"
                    value={employeeData.degree_upload}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() => deleteFile("degree_upload")}
                    error={errors.degree_upload}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Skills Acquired
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="  text-muted"
                    name="skill_acquired"
                    value={employeeData.skill_acquired}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.skill_acquired}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.skill_acquired}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Skills Acquired Certification
                  </Form.Label>
                  <FileUploadField
                    name="certification_skill_acquired"
                    value={employeeData.certification_skill_acquired}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() => deleteFile("certification_skill_acquired")}
                    error={errors.certification_skill_acquired}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Additional Courses
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="  text-muted"
                    name="additional_courses"
                    value={employeeData.additional_courses}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onKeyDown={preventLeadingSpace}
                    isInvalid={!!errors.additional_courses}
                    disabled={isDisabled}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.additional_courses}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#334d6e" }}>
                    Additional Courses Certification
                  </Form.Label>
                  <FileUploadField
                    name="certification_additional_courses"
                    value={employeeData.certification_additional_courses}
                    onChange={(e) => handleInputChange(e, "employee")}
                    onDelete={() =>
                      deleteFile("certification_additional_courses")
                    }
                    error={errors.certification_additional_courses}
                    isLoading={photoLoad}
                    placeholder={ImagePlaceholder}
                    deleteIcon={X}
                    isDisabled={isDisabled}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
